<div class="sos-content">
  <div>
    <h4>Observação</h4>
    <div [innerHTML]="observacaoFormatada"></div>
    <div *ngIf="observacoes.length > 0">
      <div *ngFor="let item of observacoes">{{ item.descricao }}</div>
      <div *ngIf="local === 1">
        <textarea
                  class="form-control"
                  maxlength="255"
                  rows="5"
                  cols="50"
                  [(ngModel)]="observacaoSos"
                  name="observacao"
                  style="margin-top: 20px"
                  required
                  #field="ngModel"></textarea>
        <div *ngIf="!valid && !field.valid && field.dirty && field.touched" class="alert alert-danger alert-dismissable">
          <strong>Observação é obrigatório</strong>
        </div>
      </div>
    </div>
  </div>

</div>
